import { ITenant } from '@shared/models';
import useAxios, { UseAxiosResult } from 'axios-hooks';

export default function useTenants(): UseAxiosResult<ITenant[]> {
  return useAxios<ITenant[]>({
    url: 'tenants',
    method: 'GET'
  });
}
